(function ($) {
    var settings;
    var ws;
    var userColors = {};
    var userListHtml = {};
    var $form;
    var connected = false;

    //randomised evenly distributed colors
    var colors = ['#ffd300', '#005700', '#8383ff', '#9e4f46', '#008395', '#9ec1ff', '#00007b',
        '#95d34f', '#f69edb', '#d311ff', '#7b1a69', '#f61160', '#72607b', '#ffc183', '#8ca77b', '#f68308']
        .map((a) => ({sort: Math.random(), value: a})).sort((a, b) => a.sort - b.sort).map((a) => a.value);
    var defaultColor = '#E5E5E5';
    function requiredError(option) {
        console.error('"' + option + '" is required in Collab options');
    }
    function collabError(text) {
        console.error(text);
    }
    function hydrateHtml(html, otherUser){
        var user = otherUser;
        if (user === null){
            user = settings.userCode;
        }
        return html.replace(/%u/g, user).replace(/%c/g, userColors[user])
    }
    function styleField($field, changed, withLock, user){
        if (withLock) {
            if (changed){
                $field.data('collab-locked', true); //remember this field was locked by collab-pack
                $field.attr('readOnly', true);
                $field.attr('disabled', true);
            } else if ($field.data('collab-locked')) { //remove read-only only if it was locked by collab-pack
                $field.data('collab-locked', false);
                $field.attr('readOnly', false);
                $field.attr('disabled', false);
            }
        }
        if($field.attr('type') === 'checkbox'){
            $field = $field.next('span.checkbox-custom');
        }
        $field.attr('style', hydrateHtml(changed ? settings.changedStyle : settings.unchangedStyle, user));
    }
    function addUser(user){
        userColors[user] = Object.keys(userColors).length < colors.length
            ? colors[Object.keys(userColors).length]
            : defaultColor;
        userListHtml[user] = hydrateHtml(settings.userListHtml, user);
    }
    function setFieldValue($field, value){
        if($field.attr('type') === 'checkbox') {
            $field.prop('checked', value === 'true');
        } else {
            $field.val(value);
        }
    }
    function getUserListHtml(){
        var html = '';
        for (var property in userListHtml) {
            html+=userListHtml[property];
        }
        return html;
    }
    $.fn.Collab = function (options) {
        $form = $(this);
        var formName = $form.attr('name');
        var collabField = $('input[name=\'' + formName + '[collabPackField]\']');
        var collabFields = [];
        if ($form.prop('tagName') !== 'FORM') return collabError('Collab function is functional only for form elements');
        settings = $.extend({}, $.fn.Collab.defaults, options);
        if (settings.address == null) return requiredError('address');
        if (settings.code == null) return requiredError('code');
        $.fn.Collab.connect();
        var $fields = $form.find('input, select');
        $fields.on('input change', function (event) {
            if (connected){
                var $field = $(this);
                if($field.data('collab') === undefined){
                    var newVal;
                    var initialVal;
                    if($field.attr('type') === 'checkbox'){
                        newVal = $field.prop('checked');
                    } else {
                        newVal = $field.val();
                    }
                    initialVal = $field.data('initial-value');

                    var fieldName = $field.attr('name');
                    var entityProp = fieldName.split('[').pop();
                    entityProp = entityProp.substr(0,entityProp.length - 1);

                    if (collabFields.indexOf(entityProp) === -1) {
                        collabFields.push(entityProp);
                    }
                    collabField.val(collabFields.join(';'));
                    var fieldId = $field.attr('id');
                    ws.send('{"type": "change", "code": "' + settings.code + '", "userCode": "' + settings.userCode + '", "id": "' + fieldId + '", "value": "' + newVal + '", "initialValue": "' + initialVal + '", "realtime": ' + settings.realtime + '}');
                } else {
                    $field.removeData('collab');
                }
            }
        });
        $fields.each(function(event){
            if (settings.lockFields) {
                styleField($(this), false, true, null);
                if (settings.realtime && $(this).data('initial-value') !== undefined) {
                    setFieldValue($(this), $(this).data('initial-value'));
                }
            }
            var initialValue;
            if($(this).attr('type') === 'checkbox') {
                initialValue = $(this).prop('checked');
            } else {
                initialValue = $(this).val();
            }
            $(this).data('initial-value', initialValue);
        })
        $form.on('submit', function (event) {
            ws.send('{"type": "submit", "code": "' + settings.code + '", "userCode": "' + settings.userCode + '"}');
        });
        return settings;
    };

    $.fn.Collab.connect = function () {
        userColors = {};
        userListHtml = {};
        ws = new WebSocket(settings.address);
        ws.onopen = function (event) {
            ws.send('{"type": "connection", "code": "' + settings.code + '", "userCode": "' + settings.userCode + '", "realtime": ' + settings.realtime + '}');
            connected = true;
        };
        ws.onmessage = function (event) {
            var message = JSON.parse(event.data);
            var $field = $('#' + message.id);
            switch (message.type) {
                case 'users':
                    if (message.event === 'conn') {
                        if (message.user === settings.userCode) {
                            message.users.forEach(function (user) {
                                if (settings.userCode !== user) {
                                    addUser(user);
                                }
                            })
                        } else {
                            addUser(message.user);
                            $(document).trigger('connection', [message.user]);
                        }
                    } else if (message.event === 'deconn') {
                        delete userColors[message.user];
                        delete userListHtml[message.user];
                        $(document).trigger('disconnection', [message.user]);
                    }
                    if (settings.connStatusTarget != null) {
                        $(settings.connStatusTarget).html(hydrateHtml(settings.connStatusOkHtml, null));
                    }
                    if (settings.userListTarget != null) {
                        // $(settings.userListTarget).html(Object.values(userListHtml).join(''));
                        $(settings.userListTarget).html(getUserListHtml());
                    }
                    break;
                case 'change':
                    setFieldValue($field, message.value)
                    $field.data('collab','no');
                    $field.change();
                    styleField($field, true, false, message.user)
                    if (message.submit) {
                        styleField($field, false, true, null)
                    }
                    break;
                case 'lock':
                    if (settings.lockFields) {
                        styleField($field, true, true, message.user);
                    }
                    break;
                case 'unlock':
                    if (settings.lockFields) {
                        styleField($field, false, true, null)
                        if (settings.realtime) {
                            setFieldValue($field, $field.data('initial-value'))
                        }
                    }
                    break;
            }
        };
        ws.onclose = function (event) {
            if (settings.connStatusTarget != null) {
                $(settings.connStatusTarget).html(hydrateHtml(settings.connStatusKoHtml, null));
                connected = false;
            }
        };
    }

    $.fn.Collab.reconnect = function () {
        var $fields = $form.find('input, select');
        $fields.each(function(event){
            if (settings.lockFields) {
                styleField($(this), false, true, null)
            }
        })
        $.fn.Collab.connect();
    }

    $.fn.Collab.defaults = {
        address: "ws://my-ws-server:80",
        code: "collab-identifier",
        userCode: "user"+Math.floor(Math.random() * Math.floor(1000)),
        realtime: true,
        lockFields: true,
        changedStyle: null,
        unchangedStyle: null,
        connStatusTarget: null,
        connStatusOkHtml:null,
        connStatusKoHtml:null,
        userListTarget:null,
        userListHtml:null,
    };
}(jQuery));


// WEBPACK FOOTER //
// ./assets/js/collabPack.js